import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "../helpers/axiosConfig";

export default function EditUser() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [user, setUser] = useState({ username: "", observation: "", password: "", roles: "" });
  const [showPassword, setShowPassword] = useState(false);
  const roles = ["SUPERADMIN", "USER", "ANONYM"];

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.get(`auth/basicinfo/${id}`);
        setUser((prev) => ({ ...prev, ...res.data, password: "" }));
      } catch (err) {
        toast.error(
          err.response?.data?.error || "Erreur lors du chargement de l'utilisateur"
        );
      }
    };
    fetchUser();
  }, [id]);

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.put(`auth/edit/${id}`, user);

      if (res.data.error) {
        toast.error(res.data.error);
        return;
      }

      toast.success("Utilisateur modifié avec succès");
      navigate("/listusers");
    } catch (err) {
      toast.error(
        err.response?.data?.error || "Erreur lors de la modification de l'utilisateur"
      );
    }
  };

  const inputCls = "w-full bg-slate-800 border border-cyan-500/30 text-white text-sm rounded-xl px-3 py-2 focus:outline-none focus:border-cyan-400 focus:ring-2 focus:ring-cyan-400/20 transition-all placeholder-slate-500";
  const labelCls = "block text-xs font-medium text-cyan-400 mb-1";

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-950 px-4 py-10">
      <div className="w-full max-w-md bg-gray-900 border border-gray-700 rounded-2xl p-6">

        <div className="flex items-center gap-2 mb-5">
          <i className="fa fa-user-pen text-green-400"></i>
          <h2 className="text-lg font-semibold text-white">Modifier l'utilisateur</h2>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className={labelCls}>Nom d'utilisateur</label>
            <input
              type="text"
              name="username"
              value={user.username}
              onChange={handleChange}
              required
              className={inputCls}
            />
          </div>

          <div>
            <label className={labelCls}>Observation</label>
            <input
              type="text"
              name="observation"
              value={user.observation}
              onChange={handleChange}
              required
              className={inputCls}
            />
          </div>

          <div>
            <label className={labelCls}>Mot de passe</label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={user.password}
                onChange={handleChange}
                required
                className={`${inputCls} pr-9`}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-cyan-400"
              >
                <i className={showPassword ? "fa fa-eye-slash" : "fa fa-eye"}></i>
              </button>
            </div>
          </div>

          <div>
            <label className={labelCls}>Rôle</label>
            <select
              name="roles"
              value={user.roles}
              onChange={handleChange}
              required
              className={inputCls}
            >
              {roles.map((role) => (
                <option key={role} value={role}>{role}</option>
              ))}
            </select>
          </div>

          <button
            type="submit"
            className="flex items-center justify-center gap-2 w-full px-5 py-2 bg-green-600 hover:bg-green-700 text-white text-sm font-medium rounded-xl transition-colors duration-200"
          >
            <i className="fa fa-check text-xs"></i>
            Enregistrer la modification
          </button>
        </form>
      </div>
    </div>
  );
}
